import React, { Component } from 'react';
import styles from './BrandsTable.module.scss';
import TableHeader from './TableHeader';
import BrandsTableLine from './BrandsTableLine';
import { getSortedList } from './utils';

interface Props {
  list: any[];
}

export interface BrandsTableState {
  arrangeByName: 'ascending' | 'descending';
  arrangeByAddedDate: 'ascending' | 'descending';
  arrangeOrder: string[];
}

class BrandsTable extends Component<Props, BrandsTableState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      arrangeByName: 'ascending',
      arrangeByAddedDate: 'ascending',
      arrangeOrder: ['name', 'date']
    };
  }

  render() {
    const { list } = this.props;

    const sortedList = getSortedList(list, this.state);

    return (
      <div className={styles.container}>

        <TableHeader
          {...this.state}
          setState={this.setState.bind(this)}
        />

        <div className={styles.body}>
          {sortedList.map(brand =>
            <BrandsTableLine
              key={brand.id}
              brand={brand}
            />
          )}

        </div>

      </div>
    );
  }
}

export default BrandsTable;
